import React from "react";
import styles from "./CustomInputIconComponent.module.scss";

interface CustomInputIconComponentProps {
  label?: string;
  type: string;
  name: string;
  placeholder: string;
  value?: string;
  onChange: (val: string) => void;
  className?: string;
  icon?: string;
  rightIcon?: string;
  rightIconClick?: () => void;
}

export default function CustomInputIconComponent({
  label,
  type,
  name,
  placeholder,
  value,
  onChange,
  className,
  icon,
  rightIcon,
  rightIconClick,
}: CustomInputIconComponentProps) {
  return (
    <div className={styles.custom_input_icon_container}>
      {label && <p className={styles.label_text}>{label}</p>}

      <div className={`${styles.input_container} ${className}`}>
        <div className={styles.input_icon_container}>
          <img src={icon} />

          {type === "textarea" ? (
            <textarea
              id={name}
              name={name}
              placeholder={placeholder}
              className={styles.textarea}
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          ) : (
            <input
              name={name}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          )}
        </div>

        {rightIcon && (
          <button
            className={styles.input_right_icon_btn}
            onClick={rightIconClick && rightIconClick}
          >
            <img src={rightIcon} />
          </button>
        )}
      </div>
    </div>
  );
}
